import {toFixedNumber, getDomCss, customCotFormat, defaultDecimals} from './utils';

/**
 * Compara el valor recibido por socket con los valores de cada elemento al que afecta al cambio.
 * La comparación se realiza a nivel de elemento DOM porque aunque estén suscritos al mismo cambio,
 * es necesario calcular la diferencia con diferentes decimales.
 * Si se detecta el cambio, llama a _changeClassAfterCompare para que defina los nuevos estilos
 * y realice el cambio en el DOM
 * Lea la información en _defaultSocketOnMessageAction para más información.
 * @private
 * En versiones anteriores, el primer parámetro era el valor actual; pero dado que dos elementos de una misma clase pueden
 *      tener diferentes decimales, se compara selector a selector
 * @param {number} socketValue Valor nuevo. No se conoce el número de decimales con el que se entrega
 * @param {Object} $selector Selector(es) que es/son candidato(s) a ser modificado(s)
 * @param {string} type Tipo de valor: last, vol, etc..
 * @param {boolean} just1Flash Si es un valor que varía frecuentemente (estilos)
 */
const _compare = function(socketValue, $selector, type, just1Flash){
    $selector.each(function(index, elem) {
        let numDecimal = parseInt($(this).attr('data-decimal'));
        if (isNaN(numDecimal)) numDecimal = defaultDecimals[type];

        let currentVal = $(this).attr('data-value');
        let $elem = $(this);
        let suffix = '';
        if (!currentVal) {
            //Si no hay valor anterior (raro), solo pintar los nuevos datos
            $(this).attr('data-value', toFixedNumber(socketValue, numDecimal, 10));
            if (type === 'var' || type === 'varPerc') getDomCss(toFixedNumber(socketValue, numDecimal, 10), type, $(this));
            if (type === 'varPerc') suffix = '%';
            if ($(this).parent().attr('data-order')) {
                $(this).parent().attr('data-order', toFixedNumber(socketValue, numDecimal, 10));
            }
            $(this).html(customCotFormat(type, socketValue, numDecimal) + suffix);
        } else {
            let customCurrentVal = toFixedNumber(currentVal, numDecimal, 10);
            let customSocketVal = toFixedNumber(socketValue, numDecimal, 10);
            if (customCurrentVal === customSocketVal) {
                return;
            }

            $(this).attr('data-value', customSocketVal);
            if (type === 'var' || type === 'varPerc') getDomCss(toFixedNumber(customSocketVal, numDecimal, 10), type, $(this));
            //if (type === 'varPerc') suffix = '%';
            if ($(this).parent().attr('data-order')) {
                $(this).parent().attr('data-order', toFixedNumber(customSocketVal, numDecimal, 10));
            }
            $(this).html(customCotFormat(type, customSocketVal, numDecimal)+suffix);
            let customClass;
            if (type !== 'date' && type !== 'vol' && type !== 'contractVol') {
                if (customCurrentVal < customSocketVal) {
                    //Ha subido
                    customClass = just1Flash ? 'updateSUp' : 'updateUp';
                } else if (customCurrentVal > customSocketVal) {
                    customClass = just1Flash ? 'updateSDown' : 'updateDown';
                }
                $(this).addClass(customClass);
                setTimeout(function () {
                    $elem.removeClass(customClass);
                }, (just1Flash) ? 500 : 1500);
            }
        }
    });
};

/**
 * Definición del Callback por defecto cuando llega un mensaje del WS.
 * Lee todos los selectores div, con data-ticker igual al tickerId del mensaje.
 * Obtiene el precio, la variación percentual y el volumen de los atributos data-field="last|varperc|vol"
 * Y compara el valor almacenado en data-value (number) con el valor llegado por mensaje.
 * Si es superior aplica la clase 'updateSUP' (divisas, o instrumentos que fluctúan mucho)
 *  o 'updateUP' (para instrumentos menos fluctuantes)
 * Si es inferior, updateSDown o updateDown.
 * Para instrumentos muy fluctuantes se dispara un timeout de 500ms que reestablece la
 *  clase; 1500ms para los menos fluctuantes
 * Para precios y volumenes, devuelve un string con el número formateado según condiciones de customCotFormat.
 * Para var.perc. devuelve <div class="arrow-{up|down}></div> {valor percentual formateado}
 * Puede adaptar los estilos CSS acorde a este Callback
 *
 * @param jsonMessage
 */
export const defaultCallback = (jsonMessage)=>{
    let tickerId    = jsonMessage.tickerId;
    let last        = parseFloat(jsonMessage.last);
    let variation   = parseFloat(jsonMessage.var);
    let varperc     = parseFloat(jsonMessage.varPerc);
    let vol         = parseFloat(jsonMessage.vol);
    let contractVol = parseFloat(jsonMessage.contractVol);
    let isForex     = true;
    let date        = jsonMessage.date;
    let oIntraday   = $('#intraday');

    //EL NUMERO DE DECIMALES PUEDE CAMBIAR ANTE DOS ELEMENTOS DE LA MISMA CLASE

    //Obtener TODOS los selectores de dicho ticker por si hubiese que cambiar
    let $selectorActualLast         =  $('.last-'+tickerId);
    let $selectorActualVar          =  $('.var-'+tickerId);
    let $selectorActualVarPerc      =  $('.varPerc-'+tickerId);
    let $selectorActualVol          =  $('.vol-'+tickerId);
    let $selectorActualContractVol  =  $('.contractVol-'+tickerId);
    let $selectorActualDate         =  $('.date-'+tickerId);
    let $tickerIdDomGraph           =  "";

    if (oIntraday.length > 0) {
        $tickerIdDomGraph = parseInt(oIntraday.attr('data-id'))
    }

    //Evaluar componente a componente
    if($selectorActualLast.length > 0){
        _compare(last, $selectorActualLast, 'last', isForex);
    }
    if($selectorActualVar.length > 0){
        _compare(variation, $selectorActualVar, 'var', isForex);
    }
    if($selectorActualVarPerc.length > 0){
        _compare(varperc, $selectorActualVarPerc, 'varPerc', isForex);
    }
    if($selectorActualVol.length > 0){
        _compare(vol, $selectorActualVol, 'vol', isForex);
    }
    if($selectorActualContractVol.length > 0){
        _compare(contractVol, $selectorActualContractVol, 'contractVol', isForex);
    }
    if($selectorActualDate.length > 0) {
        _compare(date, $selectorActualDate, 'date', isForex);
    }
    // Evaluamos el componente de la grafica intradiaria
    if ($tickerIdDomGraph !== '' && tickerId === $tickerIdDomGraph) {
        if(intraday && intraday.hasOwnProperty('series'))
            intraday.series[0].addPoint([date, last], true, false);
    }
};